/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SelectField from "components/SelectField";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value2: "",
    value3: "",
    value4: "",
    value5: "",
    value6: "",
  },
];

export default function TaxPersonalTable02({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => setData((prev) => prev.filter((item) => item.id !== id));

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", width: 10 }}
              >
                STT
                <div className="button-action">
                  <button type="button" onClick={handleAdd}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Ngày tháng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Sản lượng dầu thô khai thác (thùng)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Sản lượng dầu thô bán (thùng)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Giá bán (USD/thùng)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Ghi chú
              </Td>
            </tr>

            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "left" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="value2"
                    onChange={(e) => handleChange(item.id, "value2", e[0])}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    type="text"
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                Tổng cộng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0,00
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0,00
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
            </tr>
          </tbody>
        </table>
        <SoftButton sx={{ mt: 1 }} variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, id, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type) {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, id });
    } else {
      onChange({ value, name, id });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: !type ? "right" : "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
